
export default {
  name: 'BlocEntete',
  props: {
    imageId: {
      type: String,
      required: true
    },
    imageCouleur: {
      type: String,
      required: true
    },
    espaceConseillers: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    style () {
      const hauteur = (this.espaceConseillers) ? '150px' : 'clamp(12.5rem, 10.714rem + 8.929vw, 18.75rem)'
      const position = (this.espaceConseillers) ? '20% -5%' : '50% 22%'

      return {
        height: hauteur,
        'background-position': position,
        'background-repeat': 'no-repeat',
        'background-image': 'url(/directus/assets/' + this.imageId + ')'
      }
    }
  }
}
